import Seo from "../components/Seo";
import Hero from "../components/sections/Hero";
import LogoMarquee from "../components/sections/LogoMarquee";
import EzProcess from "../components/sections/EzProcess";
import Services from "../components/sections/Services";
import EzScribeProof from "../components/sections/EzScribeProof";
import Showcase from "../components/sections/Showcase";
import WhoWeBuildFor from "../components/sections/WhoWeBuildFor";
import PricingPreview from "../components/sections/PricingPreview";
import FAQ from "../components/sections/FAQ";
import FinalCTA from "../components/sections/FinalCTA";

export default function Home() {
    return (
        <main data-testid="home-page">
            <Seo
                path="/"
                description="ezBuildABot builds custom AI agents, full-stack web apps, and AI landing pages for solopreneurs and small businesses. Flat monthly retainer — scoped, built, and deployed in days, not months."
            />
            <Hero />
            <LogoMarquee />
            <EzProcess />
            <Services />
            <EzScribeProof />
            <Showcase />
            <WhoWeBuildFor />
            <PricingPreview />
            <FAQ />
            <FinalCTA />
        </main>
    );
}
